function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.666 3.6a12 12 0 018.57-3.6h336.529a12 12 0 018.569 3.6l3.236 3.3a12.003 12.003 0 013.43 8.4V52H0V15.3a12 12 0 013.43-8.4l3.236-3.3z",
  fill: "url(#flapClosed_svg__paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M359 5.397H8a8 8 0 00-8 8v42.825a8 8 0 004.422 7.156l175.5 87.75a8.002 8.002 0 007.156 0l175.5-87.75A8 8 0 00367 56.222V13.397a8 8 0 00-8-8z",
  fill: "url(#flapClosed_svg__paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "flapClosed_svg__paint0_linear",
  x1: 367,
  y1: 0,
  x2: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9F864E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.389,
  stopColor: "#EDC35F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.611,
  stopColor: "#EDC35F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9F864E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flapClosed_svg__paint1_linear",
  x1: 183.5,
  y1: 5.397,
  x2: 183.5,
  y2: 145.721,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0C890"
})));

function SvgFlapClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 367 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlapClosed);
export default ForwardRef;